<template>
  <div class="field">
    <div class="field__label" :title="field.label">{{ field.label }}</div>
    <Multiselect
      :value="field.allowedBitrixFields[field.bitrixField]"
      :options="dropdownOptions"
      :show-labels="false"
      placeholder="Выберите поле"
      :searchable="false"
      @input="changeSelectedValue"
      :disabled="field.fixed"
      :class="{ 'lots-select': field.bytorgField === 'lots' }"
    />
    <Checked v-if="field.enabled" class="icon" @click="changeEnabled" />
    <Unchecked v-else class="icon" @click="changeEnabled" />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Checked from "@/assets/icons/checkbox-checked.svg";
import Unchecked from "@/assets/icons/checkbox-unchecked.svg";

export default {
  name: "BitrixFieldMappingRow",
  props: {
    field: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  components: {
    Multiselect,
    Checked,
    Unchecked,
  },
  computed: {
    dropdownOptions() {
      return Object.entries(this.field.allowedBitrixFields).map(
        ([, value]) => value,
      );
    },
  },
  methods: {
    changeSelectedValue(value) {
      if (value)
        this.$emit("change", {
          type: this.type,
          id: this.field.id,
          field: "bitrixField",
          value: Object.keys(this.field.allowedBitrixFields).find(
            (key) => this.field.allowedBitrixFields[key] === value,
          ),
        });
    },
    changeEnabled() {
      this.$emit("change", {
        type: this.type,
        id: this.field.id,
        field: "enabled",
        value: !this.field.enabled,
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../assets/less/variables.less";
@import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";

.field {
  display: grid;
  grid-template-columns: 30% 1fr max-content;
  gap: 6px;
  align-items: center;
  .field__label {
    cursor: pointer;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .multiselect {
    border-radius: 5px;
  }
  .icon {
    min-width: 34px;
    min-height: 34px;
    margin: 3px;
    color: rgb(166, 166, 166);
  }
}

.field .multiselect {
  flex: 1;
  min-width: 0;
}
:deep(.multiselect__option.multiselect__option--highlight) {
  color: @text-color;
  background-color: @bg-color-light;
}
:deep(.multiselect__single) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:deep(.multiselect--disabled .multiselect__select) {
  display: none;
}

:deep(.lots-select .multiselect__tags) {
  background-color: rgb(166, 166, 166);

  border-color: rgb(166, 166, 166);
}

:deep(.lots-select .multiselect__single) {
  background-color: rgb(166, 166, 166);
}
:deep(.multiselect--disabled) {
  opacity: 1;
}
:deep(.multiselect--disabled .multiselect__tags) {
  background-color: rgb(166, 166, 166);

  border-color: rgb(166, 166, 166);
}

:deep(.multiselect--disabled .multiselect__single) {
  background-color: rgb(166, 166, 166);
}
:deep(.multiselect__select::before) {
  color: #000;
  border-color: #000 transparent transparent;
}
</style>
